import React, { useMemo } from "react";
import { useJetpackConfigSelector } from "../../../../redux/jetpackConfig";
import { FormikFormWrapperForJetpackConfig } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import JetpackCTAEditor from "./JetpackCTAEditor";
import { buildCTAValidationSchema } from "./helper/cta_validation_schema";
import { tt } from "../../../../utils/i18n/i18n";

export default function CTAWrapper() {
  const jetpackConfig = useJetpackConfigSelector();

  const validationSchema = useMemo(() => {
    return buildCTAValidationSchema();
  }, []);

  if (jetpackConfig == null) {
    return <h1>{tt("error")}</h1>;
  }

  return (
    <FormikFormWrapperForJetpackConfig
      ChildComponent={JetpackCTAEditor}
      validationSchema={validationSchema}
    />
  );
}
